/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import HeadTittle from "../../../../../../../components/HeadTittle";
import {permissionObj} from "../../../../../../../Helpers/permission";
import routes from "../../../../../../../Routes/routes";
import RequestedBatchApprovalApp from "../Functionality/RequestedBatchApprovalApp";
import React from "react";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import RequestedDetailsSection from "./RequestedDetailsSection";
import RequestedBatchOverviewTable from "./RequestedBatchOverviewTable";
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import {
    CheckOutlineIcon,
    CommentOutlineIcon,
    DeniedOutlineIcon
} from "../../../../../../../components/buttons/IconButtons";
import CancelModal from "../../../../../Dining/Schedules/Modal/CancelModal";
import {getInfoParagraphByStatus} from "../../../../../ApprovalTracker/Model/Model";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import {handleOnClick, mapRequestedBatchRows, SUBMISSION_REQUEST_CARD_MODEL} from "../Model/Model";
import CustomCard from "../../../../../../../components/CustomCard";
import {getDateFormat} from "../../../../../../../Apis/functions";

const RequestedBatchApproval = ({ disabled }) => {
    const {
        t,
        id,
        dispatch,
        navigate,
        DEV,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        setModified,
        goBack,
        setShowApprove,
        setShowDenied,
        setShowIssueComment,
        setRow,
        genericCommentModals,
        evidence,
        showBadge,
        isAttendanceSupervisor
    } = RequestedBatchApprovalApp();

    if (!DEV &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_READ) &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_REQUEST_READ) &&
        !isAttendanceSupervisor //Used for attendance department supervisor, for can manage attendees, slice loaded in login action
        )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={disabled ? 'details' : 'batch_approval'} onBack={goBack}>
                {item?.approvalStatusId === STATUS_MODEL.PENDING_REVIEW &&
                !disabled &&
                (DEV ||
                permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_REQUEST_MANAGE_APPROVAL)) &&
                <div className={"row"}>
                    <div className={"d-flex-end gap-2"}>
                        <ButtonAction
                            Icon={CheckOutlineIcon}
                            id='btn_rbot_approved'
                            className={'btn-icon-svg-chip-button btn-outlined-success-600 w-40px h-40px minw-40px p-0'}
                            iconProps={'icon'}
                            iconClass={"mr-0"}
                            disabled={false}
                            onClick={() => {
                                setRow(item)
                                setShowApprove(true);
                            }}
                        />
                        <ButtonAction
                            Icon={DeniedOutlineIcon}
                            id='btn_rbot_denied'
                            className={'btn-icon-svg-chip-button btn-outlined-error-600 w-40px h-40px minw-40px p-0'}
                            iconProps={'icon'}
                            iconClass={"mr-0"}
                            disabled={false}
                            onClick={() => {
                                setRow(item)
                                setShowDenied(true);
                            }}
                        />
                        <ButtonAction
                            Icon={CommentOutlineIcon}
                            id='btn_rbot_changes_requests'
                            className={'btn-icon-svg-chip-button btn-outlined-warning-600 w-40px h-40px minw-40px p-0'}
                            iconProps={'icon'}
                            iconClass={"mr-0"}
                            disabled={false}
                            onClick={() => {
                                setRow(item)
                                setShowIssueComment(true);
                            }}
                        />
                    </div>
                </div>
                }
            </HeadTittle>
            <DivContainerBody>
                <div className={"mb-4"}>
                    { showBadge &&
                    (() => {
                        const data = SUBMISSION_REQUEST_CARD_MODEL.getById(item?.approvalStatusId);
                        return (
                            <CustomCard
                                classes={`border-radius-8px`}
                                classCard={`border-radius-8px ${data.classCard}`}
                                children={
                                    <div className={`d-flex flex-column justify-content-start gap-3`}>
                                        <div className={"gap-2"}>
                                            <p className={`ibl-font-w-600 fs-14px ${data?.fontColor}`}>
                                                {t(data?.title)}
                                            </p>
                                            {item?.reason && (
                                                <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                                    {item?.reason}
                                                </p>
                                            )}
                                        </div>
                                        <p className={"fs-12px font-color-shades-600"}>
                                            {t(data?.byTrans)} {item?.approverUser} ·{" "}
                                            {item?.decisionDate !== null ? getDateFormat(item?.decisionDate) : ""}
                                        </p>
                                    </div>
                                }
                            />
                        );
                    })()
                    }
                </div>
                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <RequestedDetailsSection
                            item={item}
                            evidence={evidence}
                            contentCardRef={contentCardRef}
                            statusId={item?.approvalStatusId === STATUS_MODEL.PENDING_REVIEW ? STATUS_MODEL.PENDING : item?.approvalStatusId}
                        />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        <RequestedBatchOverviewTable
                            contentTableRef={contentTableRef}
                            attendancePeriod={{startDate: item?.periodStartDate, endDate: item?.periodEndDate}}
                            statusId={item?.approvalStatusId === STATUS_MODEL.PENDING_REVIEW ? STATUS_MODEL.PENDING : item?.approvalStatusId }
                            objectItems={mapRequestedBatchRows(item?.objectItems) || []}
                        />
                    </div>
                </div>
            </DivContainerBody>

            {genericCommentModals.map(({
                                           show,
                                           setter,
                                           title,
                                           status,
                                           requiredComment
                                       }) => {
                return (
                    <>
                        <CancelModal
                            show={show}
                            onHide={() => setter(false)}
                            onConfirm={(e, comment) => {
                                handleOnClick(dispatch, navigate, id, comment, status, setModified);
                            }}
                            requiredComment={requiredComment}
                            title_modal={title}
                            description={t("are_you_sure_to_proceed")}
                            subDescription={t(getInfoParagraphByStatus(status))}
                        />
                    </>
                );
            })}
        </>
    );
};

export default RequestedBatchApproval;
